import React, { useState } from "react";
import VariableGameRounds from "./EasyVariableGameRounds";
import { postScore } from "../api/postScore";
import { Button } from "@mui/material";

const goHome = () => {
  document.location.href = "/";
  console.log("Home Page Clicked");
};

const tryAgain = () => {
  document.location.href = "/variable-game";
  console.log("Play Variable Game Clicked");
};

const EasyVariableGame: React.FC = () => {
  const [currentRound, setCurrentRound] = useState<number>(1);
  const [totalScore, setTotalScore] = useState<number>(0);
  const [gameFinished, setGameFinished] = useState<boolean>(false);

  const handleRoundCompletion = (score: number) => {
    setTotalScore((prev) => prev + score);
    console.log("score " + score);
    console.log("total score " + totalScore);
    if (currentRound < 10) {
      setCurrentRound((prev) => prev + 1);
    } else {
      setGameFinished(true);
      postScore(totalScore, 30, "variable");
    }
  };

  return (
    <div
      id="numberDisplay"
      style={{
        fontSize: "28px",
        fontWeight: "bold",
        textAlign: "center",
        marginTop: "20vh",
      }}
    >
      <h2>Memory Test: Round {currentRound} / 10</h2>
      {!gameFinished ? (
        <VariableGameRounds
          key={currentRound}
          onGameEnd={handleRoundCompletion}
        />
      ) : (
        <div>
          <h2>Final Score: {totalScore} / 30</h2>
          <Button variant="outlined" onClick={goHome} color="inherit">
            {"Home"}
          </Button>
          <Button variant="outlined" onClick={tryAgain} color="inherit">
            {"Try Again"}
          </Button>
        </div>
      )}
    </div>
  );
};

export default EasyVariableGame;
